import { render, staticRenderFns } from "./Analyzer.vue?vue&type=template&id=21200480"
import script from "./Analyzer.vue?vue&type=script&lang=js"
export * from "./Analyzer.vue?vue&type=script&lang=js"
import style0 from "./Analyzer.vue?vue&type=style&index=0&id=21200480&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports